import { useAxios } from 'zhooks'

type FolderParams = { parentId: string; rankStatus?: string; queryType?: string }
export function useFolder({ parentId, rankStatus, queryType }: FolderParams) {
  return useAxios(async (axios) => {
    const res = await axios.post('/backend-api/zhikuan/mn/sample/folder/sample-folder-list?start=0&pageSize=10000', {
      parentId,
      rankStatus,
      queryType,
    })
    return res.data
  }, { refreshDeps: [parentId, rankStatus, queryType] })
}
